import React from "react";
import logo from "../Assets/Images/Xprtme _Main_Logo.png";
import Mediaicons from "../Media icons/Mediaicons";
import Copyright from "./Copyright";
import { Row, Container, Image, Col } from "react-bootstrap";
import FooterMenus from "./FooterMenus";
import "./Footer.css";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  return (
    <footer className=" position-relative">
      <Container className={`   Menu-container`}>
        <Row
          className=" justify-content-around divider-footer text-center text-sm-start text-md-start text-lg-start text-xl-start text-xxl-start pt-5 flex-wrap gap-2 gap-lg-0  "
          xs={1}
          sm={2}
          md={3}
          lg={3}
        >
          <Col className="d-flex flex-column gap-3">
            <div className="logo-con">
              <Image
                width={200}
                height={200}
                src={logo}
                className="img-fluid"
              />
            </div>
            <h5>{t("Follow Us")}</h5>
            <Mediaicons />
          </Col>
          <FooterMenus />
        </Row>
        <div className="d-flex justify-content-end align-items-center">
          <p className="text-right text-light">
            Copyright {currentYear} | All rights reserved
          </p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
